import { render } from "./DashboardJobItem.vue?vue&type=template&id=1e40755a&scoped=true"
import script from "./DashboardJobItem.vue?vue&type=script&lang=js"
export * from "./DashboardJobItem.vue?vue&type=script&lang=js"

import "./DashboardJobItem.vue?vue&type=style&index=0&id=1e40755a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e40755a"]])

export default __exports__